import { useParams, useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "convex/react";
import { api } from "../../../../../convex/_generated/api";
import { Id } from "../../../../../convex/_generated/dataModel";
import { PricingCalculator } from "./PricingCalculator";
import { toast } from "sonner";
import { useState, useEffect } from "react";

// Define the valid status types
type BidStatus = "Draft" | "Submitted" | "Approved" | "Rejected" | "In Review";

export function BidBuilder() {
  const { bidId } = useParams();
  const navigate = useNavigate();

  const [currentBidId, setCurrentBidId] = useState<Id<"bids"> | null>(
    bidId ? (bidId as Id<"bids">) : null
  );

  const createBid = useMutation(api.bids.create);

  const bidData = useQuery(api.bids.getBid, currentBidId ? { id: currentBidId } : "skip");

  useEffect(() => {
    const initializeBid = async () => {
      if (!currentBidId) {
        try {
          const newBidId = await createBid({
            title: "New Bid",
            status: "Draft" as BidStatus,
          });
          setCurrentBidId(newBidId);
          navigate(`/bids/${newBidId}`, { replace: true });
        } catch (error) {
          console.error("Error creating new bid:", error);
          toast.error("Failed to create new bid");
        }
      }
    };

    initializeBid();
  }, [currentBidId, createBid, navigate]);

  const handleSave = async (data: any) => {
    try {
      toast.success("Bid saved successfully");
    } catch (error) {
      console.error("Error saving bid:", error);
      toast.error("Failed to save bid");
    }
  };

  if (!currentBidId) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <h1 className="mb-6 text-2xl font-bold">{bidData?.title || "New Bid"}</h1>

      <PricingCalculator bidId={currentBidId} />
    </div>
  );
}
